/**
 * DialogsManager - Gerencia todos os diálogos do PendingDomainsPanel
 * 
 * Centraliza a lógica de diálogos para reduzir a complexidade do componente principal
 */
import React from 'react';
import { Snackbar, Alert } from '@mui/material';
import FallbackDialog from '../dialogs/FallbackDialog';
import ExportFilterDialog from '../dialogs/ExportFilterDialog';
import ScrapInstructionsDialog from '../dialogs/ScrapInstructionsDialog';
import ScrapAudienceDialog from '../dialogs/ScrapAudienceDialog';
import BulkUrlImportDialog from '../dialogs/BulkUrlImportDialog';
import DomainEditDialog from '../dialogs/DomainEditDialog';

const DialogsManager = ({
    // Fallback
    fallback,
    onUpdatePercentile,
    // Export
    filterTypeDialog,
    setFilterTypeDialog,
    exportFilterType,
    setExportFilterType,
    exportFormat,
    setExportFormat,
    onExportConfirm,
    // Instructions
    instructionsDialogOpen,
    setInstructionsDialogOpen,
    // Scrap Audience
    scrapAudienceDialogOpen,
    setScrapAudienceDialogOpen,
    availableFiles,
    selectedFile,
    setSelectedFile,
    onImportFile,
    // Process
    processDialogOpen,
    setProcessDialogOpen,
    selectedDomain,
    processData,
    setProcessData,
    onProcessSubmit,
    // Bulk Import
    bulkImportOpen,
    setBulkImportOpen,
    onBulkImport,
    // Snackbar
    snackbar,
    setSnackbar
}) => {
    return (
        <>
            {/* Dialog para alterar percentil */}
            <FallbackDialog
                open={fallback.dialogOpen}
                onClose={() => fallback.setDialogOpen(false)}
                percentile={fallback.percentile}
                onPercentileChange={fallback.setPercentile}
                onUpdate={onUpdatePercentile}
                loading={fallback.loading}
            />

            {/* Dialog de Filtro para Exportação */}
            <ExportFilterDialog
                open={filterTypeDialog}
                onClose={() => setFilterTypeDialog(false)}
                filterType={exportFilterType}
                onFilterTypeChange={setExportFilterType}
                exportFormat={exportFormat}
                onExportFormatChange={setExportFormat}
                onExport={onExportConfirm}
            />

            {/* Dialog de Instruções */}
            <ScrapInstructionsDialog
                open={instructionsDialogOpen}
                onClose={() => setInstructionsDialogOpen(false)}
            />

            {/* Dialog de Seleção de Arquivo para Importação */}
            <ScrapAudienceDialog
                open={scrapAudienceDialogOpen}
                onClose={() => setScrapAudienceDialogOpen(false)}
                availableFiles={availableFiles}
                selectedFile={selectedFile}
                onFileChange={setSelectedFile}
                onImport={onImportFile}
            />

            {/* Dialog Unificado de Edição/Processamento */}
            {/* key={selectedDomain?._id} força remontagem quando o domínio muda, evitando estado obsoleto do form anterior */}
            <DomainEditDialog
                key={selectedDomain?._id}
                open={processDialogOpen}
                onClose={() => setProcessDialogOpen(false)}
                domain={selectedDomain}
                onSave={onProcessSubmit}
                isNew={false}
            />

            {/* Dialog de Importação em Massa */}
            <BulkUrlImportDialog
                open={bulkImportOpen}
                onClose={() => setBulkImportOpen(false)}
                onImport={onBulkImport}
            />

            {/* Snackbar para notificações */}
            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert
                    onClose={() => setSnackbar({ ...snackbar, open: false })}
                    severity={snackbar.severity}
                    sx={{ width: '100%' }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </>
    );
};

export default DialogsManager;
